<template>
  <div class="assess-contain">
    <div class="assess-main-contain">
        <!-- <img :src="assessImgUrl" class="assess-icon"> -->
        <div class="assess-btn" @click="showPanel = !showPanel">
            <img :src="priceImgUrl" class="assess-log">
            <div class="assess-desc">鉴定估价</div>
            <i class="el-icon-arrow-down" :class="[showPanel ? 'assess-expend' : 'assess-inpend']"></i>
        </div>
    </div>
    <div class="assess-popup-contain" :class="[showPanel ? 'assess-expend' : 'assess-inpend']">
        <div class="assess-popup-p">
            <!-- <div class="assess-title">鉴定估价</div> -->
            <div class="assess-column">
                <div class="title">价格：</div>
                <el-input
                    placeholder="请输入价格"
                    v-model="price"
                    size="small"
                    :maxlength="6"
                    @input="priceInput">
                    <template v-if="showPrice" slot="prefix">¥</template>
                </el-input>
            </div>
            <div class="assess-column">
                <div class="title">级别：</div>
                <el-select
                    placeholder="请选择级别"
                    size="small"
                    v-model="level">
                    <el-option v-for="(item, index) in levelList" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="assess-btns">
                <button class="default" @click="reserForm">重置</button>
                <button class="primary" @click="submitForm">确定</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getUserEvaluate } from '@/api/person.js'
export default {
    props: {
        collections_id: [String, Number],
        showPrice: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            assessImgUrl: require('@/assets/img/assess-bg.png'),
            priceImgUrl: require('@/assets/img/price.png'),
            showPanel: true,
            price: '',
            level: undefined,
            levelList: []
        }
    },
    watch: {
        showPanel(){
            this.$emit('changeShowPanel')
        }
    },
    mounted() {
        this.initEvaluateList()
    },
    methods: {
        priceInput(val) {
            this.price = String(val).replace(/[^\d]/g, '')
        },
        reserForm() {
            this.price = ''
            this.level = undefined
        },
        submitForm() {
            if(this.price != '' && this.level != undefined) {
                getUserEvaluate({
                    price: this.price,
                    collections_id: this.collections_id
                }).then(res => {
                    if(res && res.code == 0){
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        })
                    } else {
                        // this.$message.success('估价成功')
                        const levelItem = this.levelList.find(item => item.id == this.level)
                        this.$emit('assessSuccess', {
                            price: this.price,
                            levelImg: levelItem.pic_image,
                            levelColor: levelItem.colour,
                        })
                        // setTimeout(() => {
                        //     this.reserForm()
                        // }, 200)
                    }
                })
            }else {
                this.$message.warning('请填写价格及级别')
            }
        },
        // 初始化估价等级及图片
        initEvaluateList() {
            this.$userPost('/getEvaluate').then(res => {
                this.levelList = res
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.assess-contain{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    .assess-main-contain{
        position: relative;
        // width: 190px;
        // height: 210px;
        height: 32px;
        .assess-icon{
            width: 100%;
            height: 100%;
            z-index: 0;
        }
        .assess-btn{
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 150px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #2C9645;
            cursor: pointer;
            border-radius: 4px;
            .assess-log{
                width: 20px;
                height: 20px;
            }
            .assess-desc{
                margin-left: 3px;
                margin-right: 5px;
                font-size: 16px;
                color: #FFF;
            }
            .assess-expend{
                font-size: 16px;
                color: #FFF;
            }
            .assess-inpend{
                font-size: 16px;
                transform: rotate(180deg);
                color: #FFF;
            }
        }
    }
    .assess-popup-contain{
        // margin-top: 10px;
        transition: height 300ms ease-in-out;
        overflow: hidden;
        &.assess-expend{
            height: 140px;
        }
        &.assess-inpend{
            height: 0;
        }
        .assess-popup-p{
            width: 250px;
            padding: 10px 20px;
            box-sizing: border-box;
            background: rgba(183,233,246,0.03);
            border: 1px solid rgba(255,255,255,0.12);
            border-radius: 10px;
        }
        .assess-title{
            font-size: 18px;
            color: #FFF;
            text-align: center;
            margin-bottom: 10px;
        }
        .assess-column{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .title{
                color: #FFF;
                font-size: 16px;
                white-space: nowrap;
            }
            ::v-deep .el-input {
                border: 1px solid rgba(255,255,255,0.24);
            }
            ::v-deep .el-input__prefix{
                line-height: 32px;
            }
        }
        .assess-column+.assess-column{
            margin-top: 10px;
        }
        .assess-btns{
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            .default{
                width: 85px;
                padding: 7px 15px;
                border-radius: 4px;
                font-size: 12px;
                color: #606266;
                background-color: #FFF;
                cursor: pointer;
                &:hover{
                    opacity: 0.8;
                }
            }
            .primary{
                width: 85px;
                padding: 7px 15px;
                border-radius: 4px;
                font-size: 12px;
                color: #FFF;
                background-color: #2C9645;
                cursor: pointer;
                &:hover{
                    opacity: 0.8;
                }
            }
        }
    }
}
</style>